import Base from 'app/views/base';
import PaymentMethodRemoveModal from 'app/views/modals/payment_method_remove_modal';
import RechargeSettingsView from 'app/views/recharge_settings_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .remove_card': 'showRemoveModal',
  },

  initialize({ priority, paymentMethods, user }) {
    this.priority = priority;
    this.paymentMethods = paymentMethods;
    this.user = user;

    this.addSubview('rechargeSettings', '.recharge_settings', new RechargeSettingsView({
      model: this.user, priority: this.priority,
    }));
  },

  context() {
    return {
      name: this.model.get('name'),
      last4: this.model.get('last4'),
      exp_month: this.model.get('exp_month'),
      exp_year: this.model.get('exp_year'),
      brand: this.model.get('brand'),
      brandImgClass: this.brandImgMap(this.model.get('brand')),
    };
  },

  brandImgMap(brand) {
    const map = {
      'American Express': 'amex',
      MasterCard: 'mastercard',
      Visa: 'visa',
    };
    return map[brand] || 'credit-card-alt';
  },

  showRemoveModal(event) {
    event.preventDefault();
    if (this.removeModal) { this.removeModal.close(); }

    this.removeModal = new PaymentMethodRemoveModal({
      model: this.model,
      collection: this.paymentMethods,
      priority: this.priority,
    });
    this.removeModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/payment_methods/credit_card_details/index.js